import { gettext } from '@eventbrite/i18n';
import { Button } from '@eventbrite/marmalade';
import React from 'react';
import './NightlifeRibbon.scss';

export const NightlifeRibbon = (props: { locationSlug: string }) => {
    const { locationSlug } = props;

    const ctaLink = `/b/${locationSlug}/nightlife`;
    const ribbonTitle = gettext('Live your best nightlife \u{1FAA9}');
    const ribbonCtaText = gettext('Explore events');

    return (
        <div className="nightlife-ribbon">
            <div className="nightlife-ribbon-container">
                <div
                    className="nightlife-ribbon-title-container"
                    data-testid="nightlife-ribbon-title"
                >
                    <h2 className="eds-text-bm">{ribbonTitle}</h2>
                </div>
                <div className="nightlife-ribbon-cta">
                    <a
                        href={ctaLink || ''}
                        data-heap-id={`nightlife_ribbon_click`}
                    >
                        <Button className="nightlife-ribbon-button">
                            <span className="eds-text-bm">{ribbonCtaText}</span>
                        </Button>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default NightlifeRibbon;
